import BigNumber from 'bignumber.js';
import { Address } from 'viem';

export enum PoolStatus {
  Active = 'ACTIVE',
  Unqualified = 'UNQUALIFIED',
}

export interface IPool {
  address: Address;
  status: PoolStatus;
  commission: BigNumber;
  tvl: BigNumber;
  totalDelegators: BigNumber;
}

export interface IPoolMeta {
  address: Address;
  name: string;
  description: string;
  ipfsImageLink: string; // format - ipfs://image
  externalLink: string;
}

export interface IPoolRawMeta {
  description: string;
  // eslint-disable-next-line camelcase
  external_link: string;
  image: string; // format - ipfs://image
  name: string;
}

export interface IAccountPool {
  address: Address;
  stakedAmount: BigNumber;
}

export interface IPoolUnstake {
  id: string;
  poolAddress: Address;
  amount: BigNumber;
  executedAt: Date;
}
